import React from "react";
import SignIn from "./SignIn";
import SignUp from "./SignUp";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Card, Grid } from "@mui/material";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Auth = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Grid sx={{ marginX: "auto" }}>
      {/* <Box sx={{}}>
        <Tabs value={value} onChange={handleChange} centered>
          <Tab sx={{ fontSize: "16px" }} label="Sign In" {...a11yProps(0)} />
          <Tab sx={{ fontSize: "16px" }} label="Sign Up" {...a11yProps(1)} />
        </Tabs>
      </Box> */}
      <Box sx={{ padding: 1 }}>
        <TabPanel value={value} index={0}>
          <SignIn />
        </TabPanel>
        {/* <TabPanel value={value} index={1}>
          <SignUp />
        </TabPanel> */}
      </Box>
    </Grid>
  );
};

export default Auth;
